<ion-content>
  <!-- dismiss button -->
  <!-- <ion-row class="ion-no-padding">
    <ion-col size="12" class="ion-text-right">
      <ion-button (click)="dismiss()" fill="icon-only" color="text" class="dismiss-btn"> <ion-icon name="close"></ion-icon> </ion-button>
    </ion-col>
  </ion-row> -->
  <ion-card-header>
    <p><span class="card-title-block">Please enter student type(s) so we can match you to the right programs.</span></p>
  </ion-card-header>
  <ion-row>
    <ion-col size="12">
      <amo-multi-auto-select
        id="studenttype"
        class="ion-padding-start ion-padding-end negative-margin-top"
        [dropdown]="selectionList.studenttype.list"
        [value]="selectionList?.studenttype.selection || []"
        [allownull]="true"
        writableselectmode="true"
        label="Student Type"
        (onInputChange)="selection($event)"
        placeholder="Enter Student Type"
      >
      </amo-multi-auto-select>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12" class="ion-text-center">
      <!-- <ion-button (click)="save()" fill="solid" class="success-btn-block"> Save </ion-button> -->
      <div class="footer-text">
        <span><ion-text (click)="dismiss(true)">Skip</ion-text> if you would like to manually filter in your program search requirements </span>
      </div>
    </ion-col>
  </ion-row>
  <div class="modal-footer">
    <div class="footer-buttons">
      <div class="btn-skip">
        <ion-button (click)="dismiss(false)" fill="outline" class="skip-btn-block"> Cancel </ion-button>
      </div>
      <div class="btn-save">
        <ion-button (click)="save()" fill="solid" class="success-btn-block"> Save </ion-button>
      </div>
    </div>
  </div>
</ion-content>
